<div class="customize-fields__container">
  <div class="customize-fields__container-inner"
    [ngClass]="{'customize-fields__container-inner--open': customizeFields.field.open && !hiddenHeader && !customizeFields.channelViewEditable}">
    @if(!hiddenHeader){
      <div class="common-section-title__param-container">
        <div class="common-section-title__param-inner-container">
          <div class="common-section-title__param-band-field max-w-[858px]">
            <div class="common-section-title__param-title-band-container">
                @if (!customizeFields.channelViewEditable) {
                  <button class="common-button__icon-sm-noborder"
                    (click)="showField('open')">
                    <i class="common-icon__md"
                      [ngClass]="customizeFields.field.open?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                  </button>
                }
                <div [ngClass]="{'common-section-title__param-label-icons-container': !customizeFields.field.editableName,
                  'common-section-title__param-input-icons-container': customizeFields.field.editableName && !customizeFields.field.error,
                  'common-section-title__param-input-icons-container-error': customizeFields.field.editableName && customizeFields.field.error}">
                  @if (customizeFields.channelViewEditable) {
                    <i [class]="'common-icon__md ' + customizeFields.field.icon"></i>
                  }
                  @if(customizeFields.field.isHighlight){
                    <i class="lf-icon-important common-icon__md-highlight"></i>
                  }
                  @if(customizeFields.field.private){
                    <i class="lf-icon-step-done common-icon__md"></i>
                  }
                  @if(customizeFields.field.editableName && !previewMode){
                    <input
                      #customizeFieldInput
                      type="text"
                      class="common-section-title__param-input-group"
                      [(ngModel)]="customizeFields.field.label"
                      pAutoFocus
                      [autofocus]="customizeFields.field.editableName && !previewMode && typeView !== 'translationsViewEditable'&& typeView !== 'translationsViewNoEditable'"
                      [disabled]="concept?.disabled || previewMode"
                      [maxLength]="customizeFields.maxlengthInput"
                      (keyup)="checkErrorLabel(customizeFields.field)"
                      (blur)="changeEditableField(customizeFields.field)"
                    />
                  }
                  @else {
                    <span-tooltip
                      class="common-section-title__param-label-band"
                      [text]="customizeFields.field.label">
                    </span-tooltip>
                  }
                </div>
              <!-- </div> -->
            </div>
            @if (!concept.disabled && typeView !== 'translationsViewNoEditable') {
              @if (!customizeFields.channelViewEditable && !customizeFields.field.instantiated && typeView !== 'translationsViewEditable') {
                <button-with-menu-action
                  [item]="customizeFields.fieldOptions"
                  [disabledClick]="customizeFields.disabledClick"
                  (launchActionEmitter)="launchFieldAction($event.action)">
                </button-with-menu-action>
              }
              @else if (customizeFields.channelViewEditable || customizeFields.field.instantiated || typeView === 'translationsViewEditable') {
                @if (customizeFields.field.editableName) {
                  <button
                    class="common-button__icon-md-noborder"
                    (click)="changeEditableField(customizeFields.field)"
                    [disabled]="(customizeFields.field.error && typeView !== 'translationsViewEditable') || (typeView === 'translationsViewEditable' && !customizeFields.field.label)">
                    <i class="lf-icon-check common-icon__md">
                    </i>
                  </button>
                }
                @else {
                  <button
                    class="common-button__icon-md-noborder"
                    (click)="customizeFields.field.editableName = !customizeFields.field.editableName"
                    [disabled]="concept?.disabled">
                    <i class="lf-icon-editable-form common-icon__md">
                    </i>
                  </button>
                }
              }
            }
          </div>
        </div>
        @if(customizeFields.field.error){
          <div class="common-section-title__param-error-container">
            <span [afTranslate]="'common.field-mandatory'">_Campo obligatorio</span>
          </div>
        }
      </div>
    }
      @if (customizeFields.field.open) {
      <div [ngClass]="{ 'customize-fields__container-fields': hiddenHeader,
        'customize-fields__container-fields-with-header': !hiddenHeader }">
        @if(customizeFields.field.fieldTypeId === 'templ' || customizeFields.field.fieldTypeId === 'task' || customizeFields.field.fieldTypeId === 'alert'){
          <div class="customize-fields__container-description-field">
            {{customizeFields.infoDescription}}
          </div>
        }
        <div class="customize-fields__container-inner-fields">
          @if(customizeFields.field.requiredFields && !previewMode){
            <div class="common-container__mandatory-obligatory-message-form">
              <span class="common-tag__mandatory-text-asterisk">*</span>
              <span class="common-tag__mandatory-label-text-obligatory-message"
                [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
            </div>
          }
          @if(customizeFields.field.fieldTypeId !== 'txchk' && customizeFields.field.fieldTypeId !== 'templ' && customizeFields.field.fieldTypeId !== 'task' && customizeFields.field.fieldTypeId !== 'alert'){
            <field-type-text-simple
              [field]="customizeFields.titleField"
              [preSelectItem]="customizeFields.field.extendedLabel"
              (itemSelected)="itemSelected($event, 'extendedLabel')">
            </field-type-text-simple>
          }
          <field-type-rich-text-editable
            [field]="customizeFields.descriptionField"
            [preSelectItem]="customizeFields.field.description"
            (itemSelected)="itemSelected($event, 'description')">
          </field-type-rich-text-editable>
          @if(typeView !== 'channelView' && typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable' && customizeFields.field.fieldTypeId !== 'templ' && customizeFields.field.fieldTypeId !== 'task' && customizeFields.field.fieldTypeId !== 'alert'){
            <field-type-list-simple [field]="customizeFields.contentReportInfo"
              [preSelectItem]="customizeFields.field.reportFieldId"
              [listValues]="customizeFields.reportList"
              (itemSelected)="itemSelected($event, 'reportFieldId')">
            </field-type-list-simple>
          }
          @if(concept?.poll){
            <visibility
                [concept]="concept"
                [visibilityItems]="visibilityItems"
                [selectedListValues]="customizeFields.field.listVisibleValues"
                [selectedFields]="customizeFields.field.fieldVisibleValues"
                [orCondition]="customizeFields.field.visibilityOr"
                [itemConfigured]="customizeFields.field"
                [previewMode]="customizeFields.field.noEditable || previewMode"
                (visibilityOpen)="openVisibility($event)">
            </visibility>
          }
          @switch (customizeFields.field.fieldTypeIdPainted) {
            @case ('text') {
              <customize-field-text
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [fieldContainer]="fieldContainer"
                [typeView]="typeView"
                [previewMode]="previewMode"
                [disabledFormTranslations]="disabledFormTranslations">
              </customize-field-text>
            }
            @case ('date') {
              <customize-field-date
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [typeView]="typeView"
                [previewMode]="previewMode">
              </customize-field-date>
            }
            @case ('num') {
              <customize-field-num
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [typeView]="typeView"
                [previewMode]="previewMode">
              </customize-field-num>
            }
            @case ('money') {
              <customize-field-money
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [previewMode]="previewMode">
              </customize-field-money>
            }
            @case ('l-co') {
              <customize-field-other
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [previewMode]="previewMode">
              </customize-field-other>
            }
            @case ('bool') {
              <customize-field-bool
                [field]="customizeFields.field"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [concept]="concept"
                [previewMode]="previewMode"
                [actionType]="actionType">
              </customize-field-bool>
            }
            @case ('list') {
              <customize-field-list
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [field]="customizeFields.field"
                [concept]="concept"
                [typeView]="typeView"
                [previewMode]="previewMode"
                [actionType]="actionType">
              </customize-field-list>
            }
            @case ('formu') {
              <customize-field-formula
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [field]="customizeFields.field"
                [concept]="concept"
                [previewMode]="previewMode">
              </customize-field-formula>
            }
            @case ('templ') {
              <field-type-list-simple [field]="customizeFields.fieldTemplates"
                [concept]="concept"
                [preSelectItem]="customizeFields.field.documentTemplateId"
                [listValues]="customizeFields.templatesList"
                (itemSelected)="itemSelected($event, 'documentId')">
              </field-type-list-simple>
              <customize-fields-switch-form
                [field]="customizeFields.field"
                [small]="true"
                [concept]="concept"
                [isPrivate]="isPrivate"
                [hiddenInLandings]="hiddenInLandings"
                [previewMode]="previewMode"></customize-fields-switch-form>
            }
            @default {
            <!--
              @case ('rich')
              @case ('user')
              @case ('file')
              @case ('txchk')
              @case ('task')
              @case ('alert')
            -->
              @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
                <div class="customize-fields-switch-form__container">
                  <customize-fields-switch-form
                    [field]="customizeFields.field"
                    [small]="true"
                    [concept]="concept"
                    [isPrivate]="isPrivate"
                    [hiddenInLandings]="hiddenInLandings"
                    [previewMode]="previewMode"></customize-fields-switch-form>
                  @if(customizeFields.field.fieldTypeId === 'user'){
                    <field-type-switch
                      [field]="customizeFields.multipleField"
                      [small]="true"
                      [preSelectItem]="customizeFields.field.multiple"
                      [disabled]="customizeFields.field.noEditable || previewMode"
                      (itemSelected)="itemSelected($event, 'multiple')">
                    </field-type-switch>
                  }@else if(customizeFields.field.fieldTypeId === 'rich'){
                    <field-type-switch
                      [field]="customizeFields.editableField"
                      [small]="true"
                      [preSelectItem]="customizeFields.field.isEditable"
                      [disabled]="concept.disabled || previewMode"
                      (itemSelected)="itemSelected($event, 'isEditable')">
                    </field-type-switch>
                  }
                </div>
              }
            }
          }
        </div>
      </div>
    }
  </div>
  @if(!hiddenHeader && !customizeFields.channelViewEditable && (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable')){
    <div class="customize-fields__container-drag-button">
      <button class="common-button__icon-md-drag-handle"
        cdkDragHandle
        [disabled]="concept.disabled && concept.poll"
        [cdkDragHandleDisabled]="concept.disabled && concept.poll">
        <i class="lf-icon-arrow-up-down common-icon__md"></i>
      </button>
    </div>
  }
</div>
